exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".logo[data-v-9d792faa]{margin:20px;padding:20px;-webkit-box-sizing:border-box;box-sizing:border-box}.logo.black[data-v-9d792faa]{background:#333}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/styleguide/logos.vue"],"names":[],"mappings":"AACA,uBACE,YAAa,AACb,aAAc,AACd,8BAA+B,AACvB,qBAAuB,CAChC,AACD,6BACE,eAAiB,CAClB","file":"logos.vue","sourcesContent":["\n.logo[data-v-9d792faa] {\n  margin: 20px;\n  padding: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.logo.black[data-v-9d792faa] {\n  background: #333;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9d792faa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/styleguide/logos.vue
// module id = 1224
// module chunks = 3